import { render } from "./MarketingCampaignStepEditor.vue?vue&type=template&id=1959f1de&scoped=true"
import script from "./MarketingCampaignStepEditor.vue?vue&type=script&lang=js"
export * from "./MarketingCampaignStepEditor.vue?vue&type=script&lang=js"

import "./MarketingCampaignStepEditor.vue?vue&type=style&index=0&id=1959f1de&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3624/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1959f1de"]])

export default __exports__